import React from 'react'

const CatalogPageCheckBox = ({ checked, onChange }) => {
  return (
    <div onClick={onChange} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
      {checked ? (
        // SVG для НАЖАТОГО состояния
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_3329_69928)">
            <mask id="path-1-inside-1_3329_69928" fill="white">
              <path d="M2 5C2 2.79086 3.79086 1 6 1H14C16.2091 1 18 2.79086 18 5V13C18 15.2091 16.2091 17 14 17H6C3.79086 17 2 15.2091 2 13V5Z"/>
            </mask>
            <path d="M2 5C2 2.79086 3.79086 1 6 1H14C16.2091 1 18 2.79086 18 5V13C18 15.2091 16.2091 17 14 17H6C3.79086 17 2 15.2091 2 13V5Z" fill="#030213" shapeRendering="crispEdges"/>
            <path d="M6 1V2H14V1V0H6V1ZM18 5H17V13H18H19V5H18ZM14 17V16H6V17V18H14V17ZM2 13H3V5H2H1V13H2ZM6 17V16C4.34315 16 3 14.6569 3 13H2H1C1 15.7614 3.23858 18 6 18V17ZM18 13H17C17 14.6569 15.6569 16 14 16V17V18C16.7614 18 19 15.7614 19 13H18ZM14 1V2C15.6569 2 17 3.34315 17 5H18H19C19 2.23858 16.7614 0 14 0V1ZM6 1V0C3.23858 0 1 2.23858 1 5H2H3C3 3.34315 4.34315 2 6 2V1Z" fill="black" fillOpacity="0.1" mask="url(#path-1-inside-1_3329_69928)"/>
            <path d="M14.6663 5.5L8.24967 11.9167L5.33301 9" stroke="white" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
          </g>
          <defs>
            <filter id="filter0_d_3329_69928" x="0" y="0" width="20" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3329_69928"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3329_69928" result="shape"/>
            </filter>
          </defs>
        </svg>
      ) : (
        // SVG для НЕЖАТОГО состояния
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_3329_69927)">
            <mask id="path-1-inside-1_3329_69927" fill="white">
              <path d="M2 5C2 2.79086 3.79086 1 6 1H14C16.2091 1 18 2.79086 18 5V13C18 15.2091 16.2091 17 14 17H6C3.79086 17 2 15.2091 2 13V5Z" />
            </mask>
            <path d="M2 5C2 2.79086 3.79086 1 6 1H14C16.2091 1 18 2.79086 18 5V13C18 15.2091 16.2091 17 14 17H6C3.79086 17 2 15.2091 2 13V5Z" fill="#F3F3F5" />
            <path d="M6 1V2H14V1V0H6V1ZM18 5H17V13H18H19V5H18ZM14 17V16H6V17V18H14V17ZM2 13H3V5H2H1V13H2ZM6 17V16C4.34315 16 3 14.6569 3 13H2H1C1 15.7614 3.23858 18 6 18V17ZM18 13H17C17 14.6569 15.6569 16 14 16V17V18C16.7614 18 19 15.7614 19 13H18ZM14 1V2C15.6569 2 17 3.34315 17 5H18H19C19 2.23858 16.7614 0 14 0V1ZM6 1V0C3.23858 0 1 2.23858 1 5H2H3C3 3.34315 4.34315 2 6 2V1Z" fill="black" fillOpacity="0.1" mask="url(#path-1-inside-1_3329_69927)" />
          </g>
          <defs>
            <filter id="filter0_d_3329_69927" x="0" y="0" width="20" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3329_69927" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3329_69927" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
    </div>
  );
};

export default CatalogPageCheckBox